import { Box, Button, Grid, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './InviteTeammateSuggestion.messages';
import { InviteTeammateSuggestionProps } from './InviteTeammateSuggestion.types';

export const InviteTeammateSuggestion: FC<InviteTeammateSuggestionProps> = memo((props) => {
    const { onInviteTeammate } = props;

    return (
        <Box color='midnight20' radius='small' width='100%' spacing='16'>
            <Grid gap={12}>
                <Text font='label' fontSize='large'>
                    {messages.label}
                </Text>

                <Text font='body' fontSize='small'>
                    {messages.labelInvite}
                </Text>

                <Grid justifyItems='end'>
                    <Button size='small' variant='outline' color='midnight80' onClick={onInviteTeammate}>
                        {messages.buttonInvite}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
});

InviteTeammateSuggestion.displayName = 'InviteTeammateSuggestion';
